/* Afroyla Biggest Sale 2026 signup LP — CTA scrollIntoView (Horizon theme kills window.scrollTo, see brand
 * memory) + reviews carousel dot sync (mobile scroll-snap track → active dot).
 */
(function () {
  var root = document.querySelector('[data-abs]');
  if (!root) return;
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ---- every CTA scrolls to the form card ----
  root.addEventListener('click', function (e) {
    var a = e.target.closest('[data-abs-scrollto]');
    if (!a) return;
    var el = document.querySelector(a.getAttribute('href'));
    if (!el) return;
    e.preventDefault();
    el.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  });

  // ---- reviews: sync dot nav with the scroll-snap track (mobile only; desktop hides the dots via CSS) ----
  var track = root.querySelector('[data-abs-reviews-track]');
  var dots = root.querySelectorAll('[data-abs-dot]');
  if (track && dots.length) {
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var card = track.children[Number(dot.dataset.absDot)];
        if (card) card.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', inline: 'center', block: 'nearest' });
      });
    });
    var syncTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(function () {
        var cards = [].slice.call(track.children);
        var center = track.scrollLeft + track.clientWidth / 2;
        var active = 0, best = Infinity;
        cards.forEach(function (card, i) {
          var mid = card.offsetLeft + card.offsetWidth / 2;
          var dist = Math.abs(mid - center);
          if (dist < best) { best = dist; active = i; }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === active); });
      }, 100);
    }, { passive: true });
  }
})();
